import { UUID } from "../../../typings/global";
import { CommissionsSettingsLevelEnumeration } from "../../enumerations/types";
import {
  CommissionsSettingsLevel,
  CommissionsSettingsLevelBase,
  CommissionsSettingsLevelRule,
  CreateUpdateCommissionsSettingsLevel,
  CreateUpdateCommissionsSettingsLevelRule,
} from "./types";

export const convertCommissionsSettingsLevelToCreateUpdateObject = (
  level: CommissionsSettingsLevel,
): CreateUpdateCommissionsSettingsLevel => {
  const { id, nextLevel, formerLevels, rules, bailAccountSettings, attachments, requiredPromotionRank, ...data } =
    level;

  return { ...data, nextLevelId: level.nextLevel?.id, requiredPromotionRankId: requiredPromotionRank?.id };
};

export const convertCommissionsSettingsLevelRuleToCreateUpdateObject = (
  rule: CommissionsSettingsLevelRule,
): CreateUpdateCommissionsSettingsLevelRule => {
  const { id, createdAt, updatedAt, productGroup, institution, product, ...data } = rule;

  return {
    ...data,
    productGroupId: rule.productGroup?.id,
    institutionId: rule.institution?.id,
    productId: rule.product?.id,
  };
};

export const createCommissionsSettingsLevelChain = (
  levels: CommissionsSettingsLevelEnumeration[],
  startLevelId: UUID,
) => {
  const levelMap = new Map<UUID, CommissionsSettingsLevelEnumeration>();
  levels.forEach((level) => {
    levelMap.set(level.id, level);
  });

  const result: CommissionsSettingsLevelEnumeration[] = [];
  let currentLevelId: UUID | undefined = startLevelId;

  while (currentLevelId) {
    const currentLevel = levelMap.get(currentLevelId);
    if (!currentLevel) break;

    result.push(currentLevel);
    currentLevelId = currentLevel.nextLevelId;
  }

  return result;
};

export const formatCommissionsLevelName = (level?: CommissionsSettingsLevelBase) =>
  level ? level.code + " - " + level.name : undefined;
